export class WindowManager {
	public static namespace = '__ksys-apps__';

    public static has(key: string): boolean {
		return WindowManager.getByKey(key) !== undefined;
	}

	public static get(key: string) {
		return WindowManager.getByKey(key);
	}

	public static set(key: string, value: any) {
		if (!WindowManager.window) {
			return;
		}
		if (!WindowManager.window[WindowManager.namespace]) {
			WindowManager.window[WindowManager.namespace] = {};
		}
		WindowManager.window[WindowManager.namespace][key] = value;
	}

	private static get window() {
		return window as Record<string, any>;
	}

	private static getNamespace() {
		if (!WindowManager.window) {
			return {};
		}
		return WindowManager.window[WindowManager.namespace] || {};
	}

	private static getByKey(key: string) {
		return WindowManager.getNamespace()[key];
	}
}



// WEBPACK FOOTER //
// ./src/utils/WindowManager.ts